// Centralized routes to avoid "magic strings" scattered throughout the codebase.
// If any route changes, you only need to update this file.
const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CREATE_ORG: '/create-organization',
  COMPLETE_PROFILE: '/complete-profile',
  ORGANIZATION_CONFIGURATION: '/organization/configuration',
  SET_ORGANIZATION_STRUCTURE: '/organization/structure',
  INVITE_USERS: '/organization/invite-users',
  SET_CLEANING_STANDARDS: '/organization/set-cleaning-standards',
  FACILITY_SELECTION: '/facility-selection',
};

export default ROUTES;
